module.exports = require("lru-cache");


//////////////////
// WEBPACK FOOTER
// external "lru-cache"
// module id = 7
// module chunks = 0